/* globals PLUG, CF */
import "./parseq.js";

(function (Utils) {

    "use strict";

// =============================================================================
// GENERAL
// =============================================================================

    function getUrlParam(name, queryString = location.search) {

// Returns the value for the param with the give name, or undefined if no value is found.

        if (queryString.charAt(0) === "?") {
            queryString = queryString.slice(1);
        }
        const paramMatch = queryString.split("&").find(function (param) {
            return (param.split("=")[0] === name);
        });
        return (
            paramMatch !== undefined
            ? paramMatch.split("=")[1]
            : undefined
        );
    }

    function setUrlParam(queryString, name, value) {
        if (queryString.charAt(0) === "?") {
            queryString = queryString.slice(1);
        }
        if (getUrlParam(name, queryString) !== undefined) {
            console.log("heard");
            const params = queryString.split("&");
            let paramIndex;
            params.forEach(function (param, index) {
                if (param.split("=")[0] === name) {
                    paramIndex = index;
                }
                return (param.split("=")[0] === name);
            });
            params[paramIndex] = name + "=" + value;
            return "?" + params.join("&");
        }
        return (
            queryString !== ""
            ? `?${queryString}&${name}=${value}`
            : `?${name}=${value}`
        );
    }

    function removeUrlParam(queryString, name) {
        if (queryString.charAt(0) === "?") {
            queryString = queryString.slice(1);
        }
        if (getUrlParam(name, queryString) !== undefined) {
            const params = queryString.split("&").filter(function (keyValueString) {
                const keyValuePair = keyValueString.split("=");
                return keyValuePair[0] !== name;
            });
            return (
                params.length
                ? "?" + params.join("&")
                : ""
            );
        }
    }

    function isMobile(breakpoint = PLUG.breakpoints["tablet-md"]) {
        return (window.innerWidth < breakpoint);
    }

    function waitUntilTrue(
        testFcn, // When this function returns a truthy value, we are done.
        cb, // The callback function we call when fcn evaluates to a truthy value or we timeout.
        interval = 200, // The minimum number of milliseconds to wait in between checks.
        limit = 50 // The maximum number of failures we allow before throwing an error.
    ) {
        if (testFcn()) {
            return cb();
        }
        limit -= 1;
        if (limit === 0) {
            return cb(undefined, "timeout");
        }
        setTimeout(waitUntilTrue, interval, testFcn, cb, interval, limit);
    }

    function getCookie(name) {
        return document.cookie.split("; ").find(function (cookieString) {
            return (cookieString.split("=")[0] === name);
        });
    }

    function setCookie(name, value, maxAgeInSeconds) {
        let cookieString = `${name}=${value}`;
        if (maxAgeInSeconds) {
            cookieString += `; max-age=${maxAgeInSeconds}`;
        }
        document.cookie = cookieString;
    }

// For the following functions, the 'inputArray' can be any indexable object
// that has a valid length property.

    function filterArray(inputArray, filter) {
        const outputArray = [];
        if (!inputArray.length) {
            return outputArray;
        }
        let k = 0;
        while (k < inputArray.length) {
            if (filter(inputArray[k], k, inputArray)) {
                outputArray.push(inputArray[k]);
            }
            k += 1;
        }
        return outputArray;
    }

    function mapArray(inputArray, map) {
        const outputArray = [];
        if (!inputArray.length) {
            return outputArray;
        }
        let k = 0;
        while (k < inputArray.length) {
            outputArray[k] = map(inputArray[k], k);
            k += 1;
        }
        return outputArray;
    }

    function forEach(inputArray, fcn) {
        if (inputArray.length) {
            let k = 0;
            while (k < inputArray.length) {
                fcn(inputArray[k], k, inputArray);
                k += 1;
            }
        }
    }

    function find(inputArray, fcn, returnIndex = false) {
        if (inputArray.length) {
            let k = 0;
            while (k < inputArray.length) {
                if (fcn(inputArray[k], k, inputArray)) {
                    return returnIndex ? k : inputArray[k];
                }
                k += 1;
            }
        }
    }


// =============================================================================
// Parseq
// =============================================================================

    const Parseq = PLUG.import("Parseq");

// =============================================================================
// STRING MANIPULATION
// =============================================================================

    function capitalize(str) {
        const chars = str.split("");
        chars[0] = chars[0].toUpperCase();
        return chars.join("");
    }

    function camelCase(str, capitalizeFirstLetter = true) {
        const sepRegex = /[ -_]+/g;
        const parts = str.split(sepRegex).map(capitalize);
        if (!capitalizeFirstLetter) {
            parts[0] = parts[0].toLowerCase();
        }
        return parts.join("");
    }

    const isoCodeToPrefix = {
		HKD: "HK",
		CAD: "C",
		NZD: "NZ",
		SGD: "S",
		AUD: "A"
	};

    function formatMoney(price, useCents = true) {
        const money = PLUG.moneyFormat.replace(
            "{{amount}}",
            (useCents ? price/100 : price).toFixed(2)
        );
        return (
            Object.keys(isoCodeToPrefix).includes(PLUG.selectedCurrency)
            ? isoCodeToPrefix[PLUG.selectedCurrency] + money
            : money
        );
    }

// =============================================================================
// MEDIA
// =============================================================================

    function formatImageSource(
        baseSrc, // e.g. "//cdn.shopify.com/.../img-name.jpg"
        dimensions, // e.g. "300x400"
        crop = false // e.g. "center"
    ) {
        const fileType = [".png", ".jpg", ".pjpg", ".gif"].find(function (type) {
            return baseSrc.includes(type);
        });
        const suffix = "_" + dimensions + (crop ? "_crop_" + crop : "") + fileType;
        return baseSrc.replace(fileType, suffix);
    }

// =============================================================================
// DOM MANIPULATION
// =============================================================================

    function afterNextRepaint(fcn) {
        window.requestAnimationFrame(function () {
            setTimeout(fcn, 0);
        });
    }

    function addClasses(elements, ...classes) {
        let k = 0;
        while (k < elements.length) {
            elements[k].classList.add(...classes);
            k += 1;
        }
    }

    function removeClasses(elements, ...classes) {
        let k = 0;
        while (k < elements.length) {
            elements[k].classList.remove(...classes);
            k += 1;
        }
    }

    function extractElement(element) {
        return element.parentElement.removeChild(element);
    }

    function replaceElement(oldElement, newElement) {
        oldElement.parentElement.insertBefore(newElement, oldElement);
        return extractElement(oldElement);
    }

    function removeChildren(parent, requiredClass) {
        const children = Array.from(parent.children);
        let k = 0;
        while (k < children.length) {
            const childK = children[k];
            if (
                !requiredClass
                || childK.classList.contains(requiredClass)
            ) {
                parent.removeChild(childK);
            }
            k += 1;
        }
    }

    function setAttributes(ele, attributes) {
        Object.keys(attributes).forEach(function (name) {
            ele.setAttribute(name, attributes[name]);
        });
        return ele;
    }

    // Private
    function loadingSvg() {
        const ns = "http://www.w3.org/2000/svg";

        const svg = document.createElementNS(ns, "svg");
        svg.setAttribute("aria-hidden", "true");
        svg.setAttribute("focusable", "false");
        svg.setAttribute("role", "presentation");
        svg.setAttribute("class", "icon spinner-icon");
        svg.setAttribute("viewBox", "0 0 20 20");

        const path = document.createElementNS(ns, "path");
        path.setAttribute("d", "M7.229 1.173a9.25 9.25 0 1 0 11.655 11.412 1.25 1.25 0 1 0-2.4-.698 6.75 6.75 0 1 1-8.506-8.329 1.25 1.25 0 1 0-.75-2.385z");
        path.setAttribute("fill", "currentColor");

        svg.appendChild(path);

        const wrapper = document.createElement("span");
        wrapper.setAttribute("data-loader", true);
        wrapper.className = "is-hidden";
        wrapper.appendChild(svg);

        return wrapper;
    }

    function setButtonLoadingState(button, loading) {

// Takes a 'button' element and starts the loading animation if 'loading' is true,
// otherwise it stops the loading animation. If there is no load svg inside of the
// button, we build one.

        let loader = button.querySelector("[data-loader]");
        let content = button.querySelector("[data-button-content]");

        if (!loader) {
            loader = loadingSvg();
            if (!content) {
                content = document.createElement("span");
                content.setAttribute("data-button-content", "true");
                let k = 0;
                while (k < button.childNodes.length) {
                    let childNodeK = button.childNodes[k];
                    if (childNodeK.nodeType === 1 || childNodeK.nodeType === 3) { // If it is an element or text node.
                        content.appendChild(childNodeK);
                    }
                    k += 1;
                }
                button.appendChild(content);
            }
            button.appendChild(loader);
        }

        if (!content) { // Loader is present but content is not.
            return;
        }

        if (loading) {
            button.disabled = true;
            content.style.opacity = "0";
            loader.classList.remove("is-hidden");
        } else {
            button.disabled = false;
            loader.classList.add("is-hidden");
            content.style.opacity = "1";
        }
    }


    function convertDomNodeToString(node) {
        const xmlSerializer = new XMLSerializer();
        return xmlSerializer.serializeToString(node);
    }

    function throttlerConstructor() {

// A 'throttler' is used to synchronize a repaint inducing event handler to the
// screen's framerate.

        let queuedCallback;
        return function onEvent(callback) {
            if (!queuedCallback) {
                window.requestAnimationFrame(function () {
                    const cb = queuedCallback;
                    queuedCallback = null;
                    cb();
                });
            }
            queuedCallback = callback;
        };
    }

    function listboxConstructor(listbox, onChangeCallback) {
        const btn = listbox.getElementsByClassName("listbox-btn")[0];
        const carat = btn.getElementsByTagName("svg")[0];
        const activeValue = listbox.getElementsByClassName("listbox-value")[0];
        const list = listbox.getElementsByClassName("listbox-list")[0];
        const options = Array.from(list.getElementsByTagName("li"));
        const emptyValue = listbox.dataset.emptyValue;
        const showTransitionDuration = 200;

        function show() {
            listbox.classList.add("is-open");
            carat.classList.add("is-rotated");
            requestAnimationFrame(function () {
                list.classList.add("is-showing");
            });
        }

        function hide() {
            carat.classList.remove("is-rotated");
            list.classList.remove("is-showing");
            setTimeout(function () {
                listbox.classList.remove("is-open");
            }, showTransitionDuration);
        }

// Toggle the expansion state of the listbox when the button is clicked.

        btn.addEventListener("click", function () {
            return (
                listbox.classList.contains("is-open")
                ? hide()
                : show()
            );
        }, false);

// Handle option selection.

        options.forEach(function (option, index) {
            option.addEventListener("click", function () {
                hide();
                if (option.getAttribute("aria-selected") !== "true") {
                    activeValue.textContent = option.textContent;
                    if (activeValue.textContent === emptyValue) {
                        listbox.classList.add("is-empty");
                    } else {
                        listbox.classList.remove("is-empty");
                    }
                    options.forEach(function (option, j) {
                        if (index === j) {
                            option.setAttribute("aria-selected", "true");
                        } else {
                            option.removeAttribute("aria-selected");
                        }
                    });
                    onChangeCallback(option, listbox);
                }
            }, false);
        });


        function setValue(value) {
            const option = options.find(function (option) {
                return (
                    option.dataset.value === value
                    || option.textContent === value
                );
            });
            if (option && option.getAttribute("aria-selected") !== "true") {
                const optionIndex = options.indexOf(option);
                activeValue.textContent = option.textContent;
                if (activeValue.textContent === emptyValue) {
                    listbox.classList.add("is-empty");
                } else {
                    listbox.classList.remove("is-empty");
                }
                options.forEach(function (option, j) {
                    if (optionIndex === j) {
                        option.setAttribute("aria-selected", "true");
                    } else {
                        option.removeAttribute("aria-selected");
                    }
                });
            }
        }

// Retract the listbox when the button loses focus to an element other than the list.

        let hideTimer;
        btn.addEventListener("blur", function () {
            hideTimer = setTimeout(hide, 100);
        });
        list.addEventListener("focus", function () {
            clearTimeout(hideTimer);
        });

        return Object.freeze({
            setValue,
            getValue: function () {
                return (
                    activeValue.textContent !== emptyValue
                    ? activeValue.textContent
                    : undefined
                );
            }
        });
    }

// Generator Factories and Utilities

    function integer(from = 0, to = Number.MAX_SAFE_INTEGER, step = 1) {
        return function integerGenerator() {
            if (from < to) {
                const result = from;
                from += step;
                return result;
            }
        };
    }

    function element(arrayLike, gen = integer(0, arrayLike.length)) {
        return function elementGenerator(...args) {
            const elementNr = gen(...args);
            if (elementNr !== undefined) {
                return arrayLike[elementNr];
            }
        };
    }

// Requests

    function makeXmlRequest(options, cb) {
        const req = new XMLHttpRequest();

        let {
            method,
            url,
            requestBody, // (optional) JSON object to send with request.
            headerData, // (optional) e.g. { "Content-Type": "application/json", ... }
            responseType // (optional)
        } = options;

        req.open(method, url, true);

        if (responseType) {
            req.responseType = responseType;
        }

        if (headerData) {
            Object.keys(headerData).forEach(function (key) {
                req.setRequestHeader(key, headerData[key]);
            });
        }

        const contentTypeSpecified = (
            headerData
            && (
                headerData["Content-Type"] !== undefined
                || headerData["content-type"] !== undefined
            )
        );

        if (requestBody && !contentTypeSpecified) {
            req.setRequestHeader("Content-Type", "application/json");
        }

        req.onreadystatechange = function () {
            if (req.readyState === req.DONE) {
                if (req.status.toString().charAt(0) === "2") {
                    if (cb) {
                        return cb(
                            (responseType === "document") ? req.responseXML
                            : (responseType === "blob") ? req.response
                            : req.responseText
                        );
                    }
                } else {
                    const errorMsg = "Bad request: status code: " + req.status + " " + req.results;
                    if (cb) {
                        console.log(errorMsg, req.response);
                        return cb(undefined, errorMsg, req.response);
                    } else {
                        throw new Error(errorMsg);
                    }
                }
            }
        };

        req.send(requestBody);
    }


    function addItemToCart(requestBody, cb) {

// TODO: Remove entirely, use addItemsToCart instead.

// Takes the 'variantId' and 'quantity' to add (both numbers), tries to add the item
// to the cart, and then calls cb once we get a response.

        return makeXmlRequest({
            method: "POST",
            url: "/cart/add.js",
            requestBody: requestBody,
            headers: { "Content-Type": "application/json" }
        }, function done(data, reason, response) {
            // updateCartCount();
            if (reason) {
                if (response) {
                    response = JSON.parse(response);
                    const regex = /You can't add more [\w\W]+to the cart/g;
                    if (
                        response.message === "Cart Error"
                        && response.description.match(regex)
                    ) {
                        return cb(undefined, response.description.replace("You can't add more", "You can't add that many"));
                    } else {
                        return cb(undefined, response.description);
                    }
                }
                return cb(undefined, reason);
            }
            return cb(data);
        });
    }

    function addItemsToCart(itemsArray, cb) {
        return makeXmlRequest({
            method: "POST",
            url: "/cart/add.js",
            requestBody: JSON.stringify({
                "items": itemsArray
            }),
            headers: { "Content-Type": "application/json" }
        }, function done(data, reason, response) {
            if (reason) {
                if (response) {
                    response = JSON.parse(response);
                    const regex = /You can't add more [\w\W]+to the cart/g;
                    if (
                        response.message === "Cart Error"
                        && response.description.match(regex)
                    ) {
                        return cb(undefined, response.description.replace("You can't add more", "You can't add that many"));
                    } else {
                        return cb(undefined, response.description);
                    }
                }
                return cb(undefined, reason);
            }
            // updateCartCount();
            return cb();
        });
    }

    function getProduct(handle, cb) {
        try {
            return makeXmlRequest({
                method: "GET",
                url: "/products/" + handle + ".js",
                headers: { "Content-Type": "application/json" }
            }, cb);
        } catch (exception) {
            return cb(undefined, exception);
        }
    }

    // private
    function getFormData(form) {
        const data = Object.create(null);
        const inputTags = ["input", "select", "textarea"];
        inputTags.forEach(function (tag) {
            let matches = Array.from(form.getElementsByTagName(tag));
            matches.forEach(function (element) {
                if (
                    tag === "input"
                    && element.getAttribute("type") === "checkbox"
                    && !element.checked
                ) {
                    return;
                }
                data[element.getAttribute("name")] = element.value;
            });
        });
        return data;
    }

    function submitForm(options, cb) {

// Submit a form, without reloading the page.
// options:
//      - form: A form element to gather data, or properties like method/action from.
//      - data: An object containing form name value pairs. Only used if form is not preset.
//      - action: (optional) The URL string to post the form to. Default is the current url.
//      - method: (optional) The HTTP method string used to send the request. Default is "POST"
// cb - The function to call once we receive a response to our submission request.

        try {
            const form = options.form;
            const method = options.method || "POST";
            const action = options.action || (
                form
                ? (form.getAttribute("action") || location.pathname)
                : location.pathname
            );
            let data = options.data || getFormData(form);

// Convert our data object to a URL encoded string.

            const urlEncodedDataPairs = Object.keys(data).map(function (key) {
                return encodeURIComponent(key) + "=" + encodeURIComponent(data[key]);
            });
            data = urlEncodedDataPairs.join("&").replace(/%20/g, "+");

            return makeXmlRequest({
                method: method,
                url: action,
                requestBody: data,
                headerData: {
                    "Content-Type": "application/x-www-form-urlencoded"
                }
            }, cb);
        } catch (exception) {
            return cb(undefined, exception);
        }
    }

    function toDataUrl(url, cb) {

        // This function takes the url for some file (usually an image src),
        // requests it, and then transcodes the result into base64 format.

        makeXmlRequest({
            method: "GET",
            url: url,
            responseType: "blob"
        }, function done(result, reason) {
            if (reason) {
                return cb(undefined, reason);
            }
            const reader = new FileReader();
            reader.onloadend = function () {
                return cb(reader.result);
            };
            reader.readAsDataURL(result);
        });
    }

    function getFreshSection(
        sectionId, // The ID of the section to fetch, does not include 'shopify-section-'.
        cb, // The cb we pass the response data to.
        path = location.pathname, // The path to make the request to.
        queryString = location.search // E.g. ?variant_id=123456678&prop=value
    ) {

// Fetch a new version of a section using Shopify's section rendering API.

        const url = (
            queryString !== ""
            ? path + queryString + "&section_id=" + sectionId
            : path + "?section_id=" + sectionId
        );

        return makeXmlRequest({
            method: "GET",
            url: url
        }, function done(newSectionText, reason) {
            if (reason) {
                return cb(undefined, reason);
            }
            const domparser = new DOMParser();
            const parsedDoc = domparser.parseFromString(newSectionText, "text/html");
            const newSection = parsedDoc.body.children[0];
            return cb(newSection);
        });
    }

    function refreshSection(
        sectionId, // The ID of the section to fetch, does not include 'shopify-section-'.
        cb, // The function we call after the section has been replaced, or report errors to.
        path, // (optional) The path to make the request to. Defaults to current path.
        queryString // (optional) E.g. ?variant_id=123456678&prop=value
    ) {
        return getFreshSection(
            sectionId,
            function (newSection, reason) {
                if (newSection === undefined) {
                    return cb(undefined, reason);
                }
                const oldSection = document.getElementById("shopify-section-" + sectionId);
                if (!oldSection) {
                    throw new Error("Can't find old section");
                }
                const sectionParent = oldSection.parentElement;
                sectionParent.insertBefore(newSection, oldSection);
                sectionParent.removeChild(oldSection);
                return cb();
            },
            path,
            queryString
        );
    }

    // private
    const easingFunctions = {
        easeInOutCubic: function (x) {
            return (
                x < 0.5
                ? 4 * x * x * x
                : 1 - Math.pow(-2 * x + 2, 3) / 2
            );
        },
        easeOutCubic: function (x) {
            return 1 - Math.pow(1 - x, 3);
        }
    };

    function smoothScrollTo(element, y1, cb, easingType = "easeOutCubic") {
        if (typeof y1 !== "number") {
            throw new TypeError("Argument 'y1' must be a number.");
        }

        const y0 = (
            element.scrollTop !== undefined
            ? element.scrollTop
            : window.scrollY
        );
        y1 = Math.min(
            (
                element.scrollHeight !== undefined
                ? element.scrollHeight
                : document.body.getBoundingClientRect().height
            ),
            Math.max(0, y1)
        );
        const easingFunction = easingFunctions[easingType];
        const totalDistanceToScroll = y1 - y0;
        const scrollingDown = y1 > y0;
        if (y0 === y1) {
            return;
        }
        const totalDuration = 300;
        let start;
        function step(timestamp) {
            if (start === undefined) {
                start = timestamp;
            }
            const elapsed = timestamp - start;
            const percentDone = elapsed / totalDuration;
            const percentScrolled = easingFunction(percentDone);
            const yx = (
                scrollingDown
                ? Math.min(totalDistanceToScroll * percentScrolled + y0, y1)
                : Math.max(totalDistanceToScroll * percentScrolled + y0, y1)
            );
            element.scrollTo(0, yx);
            if (elapsed < totalDuration) { // Stop the animation after 2 seconds
                window.requestAnimationFrame(step);
            } else {
                if (cb) {
                    return cb();
                }
            }
        }

        window.requestAnimationFrame(step);
    }

    function buildImage(options) {
        let { className, src, alt, aspectRatio } = options;
        const img = document.createElement("img");
        img.className = className;
        img.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
        img.dataset.src = src.replace(".jpg", "_{width}x.jpg").replace(".png", "_{width}x.png");
        img.dataset.sizes = "auto";
        img.dataset.aspectratio = aspectRatio;
        img.setAttribute("alt", alt);
        img.setAttribute("draggable", "false");
        return img;
    }


// Store Specific

    function updateCustomerField(key, value, cb, saveCustomer = true) {
        try {
            CF.customerReady(function () {
                CF.customer.set(key, value);
                if (!saveCustomer) {
                    return cb();
                }
                CF.customer.save().then(function (errorObj) {
                    if (errorObj) {
                        console.log("Utils.updateCustomerField error: ", errorObj);
                    }
                    return (
                        errorObj
                        ? cb(undefined, "Utils.updateCustomerField request has failed.")
                        : cb()
                    );
                }).catch(function (err) {
                    console.error("Error updating " + key, err);
                    return cb(undefined, err);
                });
            });
        } catch (exception) {
            return cb(undefined, exception);
        }
    }

//     function updateCartCount() {
//
// // Update the cart count elements shown by the cart icon in the nav.
// // There are two, one for mobile and one for desktop.
//
//         return makeXmlRequest({
//             method: "GET",
//             url: "/cart.js"
//         }, function done(data, reason) {
//             if (data === undefined) throw new Error(reason);
//             var cartJson = JSON.parse(data);
//             var itemCount = cartJson.item_count;
//             var cartCountElements = document.getElementsByClassName("plug-nav-cart-count");
//             Array.from(cartCountElements).forEach(function (element) {
//                 element.textContent = itemCount;
//             });
//         });
//     }

    function buildDiamond(isEmpty = false, num = 1) {
        if (num === 0) {
            return document.createDocumentFragment();
        }
        const filledDiamondColor = "#f1c62d";
        const emptyDiamondColor = "#c4c4c4";
        const ns = "http://www.w3.org/2000/svg";
        const svg = document.createElementNS(ns, "svg");
        svg.classList.add("icon", "diamond-icon");
        svg.setAttribute("aria-hidden", "true");
        svg.setAttribute("focusable", "false");
        svg.setAttribute("role", "presentation");
        svg.setAttribute("viewBox", "0 0 17 14");
        svg.setAttribute("width", "17");
        svg.setAttribute("height", "14");
        const path = document.createElementNS(ns, "path");
        path.setAttribute("d", "M2.96212 0L0 3.22124H2.83333L4.50758 0H2.96212ZM5.2803 0L3.60606 3.22124H13.3939L11.7197 0H5.2803ZM12.4924 0L14.1667 3.22124H17L14.0379 0H12.4924ZM0 3.9646L6.95455 12.3894L2.83333 3.9646H0ZM3.60606 3.9646L8.5 14L13.3939 3.9646H3.60606ZM14.1667 3.9646L10.0455 12.3894L17 3.9646H14.1667Z");
        path.setAttribute("fill", isEmpty ? emptyDiamondColor : filledDiamondColor);
        svg.appendChild(path);

        if (num === 1) {
            return svg;
        }

        const docFrag = document.createDocumentFragment();
        docFrag.appendChild(svg);
        let k = 1;
        while (k < num) {
            docFrag.appendChild(svg.cloneNode(true));
            k += 1;
        }
        return docFrag;
    }

    function fillDiamondHalfway(diamondSvg, gradientId) {
        const svgns = "http://www.w3.org/2000/svg";
        const path = diamondSvg.getElementsByTagName("path")[0];
        const defs = document.createElementNS(svgns, "defs");
        const linearGradient = document.createElementNS(svgns, "linearGradient");
        const stop1 = document.createElementNS(svgns, "stop");
        const stop2 = document.createElementNS(svgns, "stop");
        path.setAttribute("fill", `url(#${gradientId})`);
        linearGradient.id = gradientId;
        stop1.setAttribute("offset", "50%");
        stop1.setAttribute("stop-color", "#f1c62d");
        stop2.setAttribute("offset", "50%");
        stop2.setAttribute("stop-opacity", "1");
        stop2.setAttribute("stop-color", "#ceced3");
        linearGradient.appendChild(stop1);
        linearGradient.appendChild(stop2);
        defs.appendChild(linearGradient);
        diamondSvg.insertBefore(defs, diamondSvg.children[0]);
    }


    Utils.export = function () {
        return Object.freeze({
            // General
            getUrlParam,
            setUrlParam,
            removeUrlParam,
            isMobile,
            waitUntilTrue,
            addClasses,
            removeClasses,
            extractElement,
            replaceElement,
            getCookie,
            setCookie,
            filterArray,
            mapArray,
            forEach,
            find,

            // Parseq
            fallback: Parseq.fallback,
            parallel: Parseq.parallel,
            parallelObject: Parseq.parallel_object,
            race: Parseq.race,
            sequence: Parseq.sequence,

            // String manipulation.
            capitalize,
            camelCase,
            formatMoney,

            // Media
            formatImageSource,

            // DOM manipulation
            afterNextRepaint,
            removeChildren,
            setAttributes,
            setButtonLoadingState,
            convertDomNodeToString,
            smoothScrollTo,
            buildImage,
            throttlerConstructor,
            listboxConstructor,

            // Generator Factories
            integer,
            element,

            // Requests
            makeXmlRequest,
            addItemToCart,
            addItemsToCart,
            getProduct,
            getFreshSection,
            refreshSection,
            submitForm,
            toDataUrl,

            // Store Specific
            // updateCartCount: updateCartCount
            updateCustomerField,
            buildDiamond,
            fillDiamondHalfway
        });
    };

})(PLUG.Utils = Object.create(null));
